import { queryOptions } from '@tanstack/react-query';
import { getComplaintChartFunction } from './getComplaintChartQueryFunction';

export const getComplaintChartQueryOptions = () => {
  return queryOptions({
    queryKey: ['ComplaintChart'],
    queryFn: () => getComplaintChartFunction(),
  });
};
